"use client";

import { useRequestMeShowStudentLabel } from "./useRequestMeShowStudentLabel";

export const useIsStudent = () => {
  const {
    query: { data: isStudent },
  } = useRequestMeShowStudentLabel();

  return isStudent;
};
